import React from 'react';
import { Icon } from 'antd';
import PropTypes from 'prop-types';


function RatingIcon(props) {
  const color = props.full ? '#f9b115' : '#636f83';
  return (
    <Icon type="star" theme="twoTone" twoToneColor={color} style={{ fontSize: props.size }} />
  );
}

RatingIcon.propTypes = {
  full: PropTypes.bool,
  size: PropTypes.string.isRequired,
};

export default RatingIcon;
